import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Logout, ResetNotifications } from '@myStore/auth/auth.actions';
import {
  faCheck,
  faPalette,
  faSignOutAlt,
} from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { SetTheme } from '@myStore/theme/theme.actions';
import { selectProfile } from '@myStore/profile-view/profile-view.selector';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { IAppState } from '@myStore/app.state';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.sass'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() public title?: string;
  @Input() public pageName?: string;
  @Input() public titleLink?: string;
  @Input() public loading: boolean | null = null;
  @Input() public editTitle: string | null = null;
  @Input() public notEditable = false;
  @Input() public showLogoutBtn: boolean | null = null;
  @Input() public showNotificationBtn = true;
  @Input() public showThemeBtn: boolean | null = null;
  @Output() public changeTitle = new EventEmitter<string>();
  public accessDenied = false;
  public is_superUser: boolean | undefined = false;
  private destroy$ = new Subject<boolean>();
  readonly faCheck = faCheck;
  readonly faLogout = faSignOutAlt;
  readonly faTheme = faPalette;

  constructor(private _store: Store<IAppState>, private _router: Router) {}

  ngOnInit() {
    this._store
      .pipe(select(selectProfile), takeUntil(this.destroy$))
      .subscribe(profile => {
        if (profile) {
          this.is_superUser = profile.is_superuser;
          this.accessDenied = profile.edu_groups?.length
            ? !profile.edu_groups?.some(group => !group.is_deleted)
            : false;
        }
      });
  }

  getLocation(): void {
    if (this.titleLink) {
      this._router.navigate([this.titleLink]);
      return;
    }
  }

  change(): void {
    if (this.editTitle) {
      this.changeTitle.emit(this.editTitle);
    }
  }

  setTheme(name: string): void {
    this._store.dispatch(new SetTheme(name));
  }

  logout(): void {
    this._store.dispatch(new ResetNotifications());
    this._store.dispatch(new Logout());
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }
}
